import { render } from "./ModalNuovoLead.vue?vue&type=template&id=396d4e37&scoped=true"
import script from "./ModalNuovoLead.vue?vue&type=script&lang=js"
export * from "./ModalNuovoLead.vue?vue&type=script&lang=js"

import "./ModalNuovoLead.vue?vue&type=style&index=0&id=396d4e37&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_apib/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-396d4e37"]])

export default __exports__